<div class="campaign-list-item-card border py-3 cursor-pointer bg-white">
  <div class="campaign-list-item-card-div mb-2">
    <img [campaignImage]="campaignEntitlement.CampaignId" alt="campaign details" class="logo mb-2 rounded" />
    <ng-container *ngIf="!campaignEntitlement.Claimed">
      <span class="back-button icon material-icons campaign-item-lock-icon text-end"> lock </span>
    </ng-container>
  </div>
  <div class="campaign-list-item-name">{{ campaignEntitlement.CampaignName }}</div>

  <ng-container *ngIf="campaignEntitlement.Claimed && campaignEntitlement.VoucherRedemptions >= 1; else showExpiry">
    <div class="campaign-list-item-expiry-date pt-2 text-info fw-bold">
      {{ 'offer.claimed' | translate }}
    </div>
  </ng-container>
  <ng-template #showExpiry>
    <div class="campaign-list-item-expiry-date pt-2">
      <ng-container *ngIf="!isDateExpired; else expired">
        {{ 'offer.expiry' | translate }} {{ campaignEntitlement.ExpiryDate | UtcToLocaltimePipe: dateOption.NgbDateFormat }}
      </ng-container>
      <ng-template #expired>
        <span class="fw-bold">
          {{ 'offer.expired' | translate }}
        </span>
      </ng-template>
    </div>
  </ng-template>
</div>
